/******************************************
 	* 接口统一管理
*******************************************/

import { download, post } from "./axios";

//p、t是需传送的参数，是一个对象

//serGetTimu是获取服务器端的题目函数
export const serGetTimu = t => post('/noper/getti', t);

//serSetTimu是给数据库添加题目
export const serSetTimu = t => post('/noper/setti', t);

//serLogin是用户登录
export const serLogin = t => post('/noper/kulogin', t);

//serIsEmail检验邮箱是否已经注册
export const serIsEmail = t => post('/noper/kuemail', t);

//serIsMark检验验证码是否正确
export const serIsMark = t => post('/noper/kumark', t);

//serIsTele检验电话号码是否已经注册
export const serIsTele = t => post('/noper/kutele', t);

//serSetRegister注册一个用户
export const serSetRegister = t => post('/noper/kuregister', t);

//serGetTextNO获取文件内容，无需核验
export const serGetTextNO = t => post('/noper/kutextno', {...t,CCR:false});

//serIsForEmail忘记密码检验邮箱是否存在
export const serIsForEmail = t => post('/noper/kuforemail', t);

//serIsForTel忘记密码检验电话是否存在
export const serIsForTel = t => post('/noper/kufortel', t);

//serIsForAnswer忘记密码检验问题
export const serIsForAnswer = t => post('/noper/kuforans', t);

//serSave是保存当前数独---放弃使用
export const serSave = t => post('/cando/kusave', t);

//serRePassword修改密码
export const serRePassword = t => post('/cando/kurepwd', t);

//serReTelnum修改电话号---放弃使用
export const serReTelnum = t => post('/cando/kuretel', t);

//serSetTabdata保存表格中的数据（把state.tabplate中的数据保存到数据库，还有时间）
export const serSetTabdata = t => post('/cando/kusavetab', t);

//serGetTabdata从数据库中获取表格的数据
export const serGetTabdata = t => post('/cando/kuloadtab', t);

//serSetSendChat共享发表
export const serSetSendChat = t => post('/cando/kusendchat', t);

//serGetChat获取共享表格的所有数据，添加了给拦截器免检查连续请求的属性CCR
export const serGetChat = t => post('/cando/kugetchat', {...t,CCR:false});

//serSetComment保存评论信息
export const serSetComment = t => post('/cando/kucomment', t);

//serSetSendEdit编辑信息
export const serSetSendEdit = t => post('/cando/kusendedit', t);

//serSetdelectcard删除信息
export const serSetdelectcard = t => post('/cando/kudelectcard', t);

//serSetLoveInfo添加喜欢
export const serSetLoveInfo = t => post('/cando/kuLoveInfo', t);

//serSetdelectcom添加喜欢
export const serSetdelectcom = t => post('/cando/kudelectcom', t);

//serGetCrsytal 查询用户水晶数
export const serGetCrsytalNum = t => post('/cando/kucrsytalnum', {...t,CCR:false});

//serGetseekHelp寻求帮助
export const serGetseekHelp = t => post('/cando/kuhelpme', t);

//serIsSubject验证题目是在当天内
export const serIsSubject = t => post('/cando/kugetsubject', {...t,CCR:false});

//serSetSubject验证题目是在当天内
export const serSetSubject = t => post('/cando/kusetsubject', {...t,CCR:false});


//serPermissions 修改用户权限---
export const serPermissions = t => post('/power/kupermissions', t);

//serSetResetPwd 修改重置用户密码
export const serSetResetPwd = t => post('/power/kuresetpword', t);

//serGetCrsytal 查询用户水晶数
export const serGetCrsytal= t => post('/power/kugetcrsytal', t);

//serSetAddCrsytal 查询用户水晶数
export const serSetaAddCrsytal= t => post('/power/kusetadcrsytal', t);

//serGetNameNum用户数量查询
export const serGetNameNum = t => post('/power/kugetnamemonum', t);

//serGetNameFu用户名模糊查询
export const serGetNameFu = t => post('/power/kugetnamemohu', t);

//serGetOldDateFu注册时间模糊查询
export const serGetOldDateFu = t => post('/power/kugetolddmohu', t);

//serGetNewDateFu最近登录时间模糊查询
export const serGetNewDateFu = t => post('/power/kugetnewdmohu', t);

//serGetTelFu最近电话号模糊查询
export const serGetTelFu = t => post('/power/kugettelmohu', t);

//serGetQuesFu问题模糊查询
export const serGetQuesFu = t => post('/power/kugetquesmohu', t);

//serGetAnswerFu问题答案模糊查询
export const serGetAnswerFu = t => post('/power/kugetanswermohu', t);

//serGetLogoutFu注销和受限模糊查询
export const serGetLogoutFu = t => post('/power/kugetlogoutmohu', t);

//serSetAddTimu添加题目
export const serSetAddTimu = t => post('/power/kusetaddtimumohu', t);

//serSetBatchAddTimu批量添加题目（需要后台管理员）
export const serSetBatchAddTimu = t => post('/power/kusetbatchtimumohu', t);

export const serDownloadApk = (fn) => download('/cando/download/apk', {}, fn );
